import type { GlobalStateType } from '@modules/global/state';

type FingerPrint3DSType = {
  browser_color_depth: string;
  browser_screen_width: string;
  browser_screen_height: string;
  browser_java_enabled: boolean;
  window_width: number;
  window_height: number;
};

export default (fingerPrint: GlobalStateType['fingerPrintData']): FingerPrint3DSType => ({
  browser_color_depth: fingerPrint?.colorDepth,
  browser_screen_width: fingerPrint?.screenResolution?.[1],
  browser_screen_height: fingerPrint?.screenResolution?.[0],
  browser_java_enabled: 'javaEnabled' in window.navigator ? window.navigator.javaEnabled() : false,
  window_width: window.outerWidth,
  window_height: window.outerHeight,
});
